// @ts-ignore
import editIcon from "../../img/edit.png";
// @ts-ignore
import deleteIcon from "../../img/delete.png";

export function SettingsCard({onEdit, onDelete, children}){
  return <div className={"card grid settingsCard"}>
    {children}
    <div className={"grid gridtwo"}>
      {onEdit&&<div onClick={onEdit} style={{cursor: "pointer"}}>
        <img className={"icon"} src={editIcon} alt={"edit"}/>
      </div>}
      {onDelete&&<div onClick={onDelete}>
        <img className={"icon"} src={deleteIcon} style={{cursor: "pointer"}} alt={"delete"}/>
      </div>}
    </div>
  </div>
}